import EditInvoiceRecipientsPopup from './InvoiceRecipients/EditInvoiceRecipientsPopup'
import PaymentHistoryItemPopup from './Payments/PaymentHistoryItemPopup'
import AddPaymentMethodPopup from './Payments/AddPaymentMethodPopup'
import EditAccountUserPopup from './BasicInfo/EditAccountUserPopup'
import PaymentCardItemPopup from './Payments/PaymentCardItemPopup'
import ConsentPreviewPopup from 'components/popups/ConsentPreview'
import EditPhonePopup from './BasicInfo/EditPhonePopup'
import EditMailPopup from './BasicInfo/EditMailPopup'
import usePopupState from '../../hooks/usePopupState'
import DeleteAccount from './Settings/DeleteAccount'
import DevicePopup from './Settings/DevicePopup'
import PinPopup from './Settings/PinPopup'

const Popups = () => {
  const { popup } = usePopupState()
  switch (popup?.type) {
    case 'paymentMethod': return <PaymentCardItemPopup id={popup?.props?.id} />
    case 'addPaymentMethod': return <AddPaymentMethodPopup />
    case 'paymentHistoryItem': return <PaymentHistoryItemPopup id={popup?.props} />
    case 'editAdditionalPhone': return <EditPhonePopup isAdditionalPhone />
    case 'editAdditionalMail': return <EditMailPopup isAdditionalMail />
    case 'privacy': return <ConsentPreviewPopup type='privacy' />
    case 'terms': return <ConsentPreviewPopup type='terms' />
    case 'licenses': return <ConsentPreviewPopup type='licenses' />
    case 'editUser': return <EditAccountUserPopup />
    case 'deleteAccount': return <DeleteAccount />
    case 'editPhone': return <EditPhonePopup />
    case 'editMail': return <EditMailPopup />
    case 'editInvoiceRecipients': return <EditInvoiceRecipientsPopup companyId={popup?.props?.companyId} />
    case 'deviceList': return <DevicePopup />
    case 'changePin': return <PinPopup />
    default: return null
  }
}

export default Popups